<template>
  <div>
    <BaseFilter title="DAYS REQUIRED" :state="availabilities">
      <template #default="{ data }">
        <b-form-checkbox-group
          v-model="selected"
          name="day-rate-filter"
          :options="parseAvailabilities(data)"
          value-field="id"
          stacked
          disabled-field="disabled"
        />
      </template>
    </BaseFilter>
  </div>
</template>

<script>
import { map, isEqual } from 'lodash/fp'
import localAsyncAction from '@/mixins/localAsyncAction'
import apiModules from '@/services'
import BaseFilter from '@/components/BaseFilter/BaseFilter'

export default {
  name: 'AvailabilityFilter',
  components: {
    BaseFilter
  },
  mixins: [
    localAsyncAction({
      key: 'availabilities',
      initialState: [],
      fetcher: {
        methodName: 'fetchAvailabilities',
        handler: apiModules.fetchAvailabilities
      }
    })
  ],
  props: {
    value: {
      type: [Number, Array],
      default: () => []
    },
    filters: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      selected: this.value
    }
  },
  watch: {
    selected(value) {
      this.$emit('input', value)
    },
    filters: {
      handler(filters) {
        this.fetchAvailabilities(filters)
      },
      deep: true
    },
    value(value) {
      if (!isEqual(value, this.selected)) {
        this.selected = value
      }
    }
  },
  created() {
    this.fetchAvailabilities(this.filters)
  },
  methods: {
    parseAvailabilities(availabilities) {
      return map(
        availability => ({
          ...availability,
          text: `${availability.days_detail}`
        }),
        availabilities
      )
    }
  }
}
</script>
